export default __webpack_public_path__ + "static/media/dallas-mavericks-logo-transparent.40c18897.png";